
# This file is used by WEB and TOUCH - if you modify this file verify BOTH !

FacetLoader = require './facet-loader.coffee'
paginationCard = require './pagination-card.coffee'
urlUtils = require './url-utils.coffee'

priceRangeTemplate = require '../../merchandising_occasions/shared/price-range.html.mustache'
priceRangeCustTemplate = require '../../merchandising_occasions/shared/price-range-custom.html.mustache'
facetTemplate = require '../../merchandising_occasions/shared/facet-template.html.mustache'
radioTemplate = require '../../merchandising_occasions/shared/radios.html.mustache'

hoganPartials = require './template-include-partials.coffee'
loadMoreTemplate = require '../../merchandising_occasions/shared/load-more-deals.html.mustache'

getCardUi = ()->
  if typeof CardUI != "object"
    return {init: ()->}
  return CardUI

Filtering = do ->

  lastRequest = ""
  pageConfig = null
  createHeadings = false
  paginatedDealIds = {}
  paginationFacets = {}
  LIMIT_INCREMENT = 10
  MIN_PAGE_DEALS = 4
  extraQueryString = ""
  initialQueryString = {}
  lastState = {}
  _attr_dataFilterQuery = "data-filter-query"
  _attr_dataHrefTemplate = "data-href-template"
  _attr_dataNextOffset = "data-next-offset"
  _attr_dataSetId = "data-set-id"
  _attr_dataTotalDeals = "data-total-deals"
  _cls_loadMoreChoices = "load-more-choices"
  _id_loadMoreDeals = "load-more-deals"
  _jsModulesMrchOcsn = "js.modules.merchandising_occasions"
  _sel_loadMoreChoices = "."+_cls_loadMoreChoices
  _sel_loadMoreDeals = "#"+_id_loadMoreDeals
  _sel_priceFilter = "#price-filter"

  _init = (pageCfg, createHeadings, queryExtra, initDoneCb) ->
    pageConfig = pageCfg

    $defaultLoadMore = $(_sel_loadMoreDeals)
    updatePaginationCardHref $defaultLoadMore
    $defaultLoadMore.on('click', loadMoreDealsEvent)

    extraQueryString = queryExtra if queryExtra
    initialQueryString = urlUtils.parseQueryString(window.location.search)

    lhnFacets = new FacetLoader(pageConfig.facets, pageConfig.subnavFacets, pageConfig.subnavFacetsMinimumDeals)
    showSubnavFacets(lhnFacets.loadedFacets)

    lhnAreaFacets = new FacetLoader(pageConfig.facets, pageConfig.subnavFacetAreaFacets, pageConfig.subnavFacetAreaMinimumDeals)
    showSubnavAreaFacets(lhnAreaFacets.loadedFacets, createHeadings)

    showPriceFilters(createHeadings)
    showSortOptions(createHeadings)

    paginationFacets = new FacetLoader(pageConfig.facets, pageConfig.paginationFacets, pageConfig.paginationFacetsMinimumDeals)

    initAtEnd(initDoneCb)

  initAtEnd = (initDoneCb) ->
    setTimeout ()->
      initPaginatedDealIds()
      initRoutes()
      initDoneCb?()
    , 0

  initCui = () ->
    getCardUi().init()

  initRoutes = () ->
    fragmentParams = urlUtils.parseLocationHash()
    if history.replaceState
      # we should parse the current state and store it here
      query = initialQueryString
      qs = urlUtils.buildQueryString(query)
      history.replaceState({stateQuery:query},document.title,window.location.pathname + qs + urlUtils.currentFragment())
      applyState {stateQuery:query}, () =>
        # TODO: consider moving the following into a "process fragment" function that can be called automatically after state is applied...
        if fragmentParams.offset
          if fragmentParams.setId and pageConfig.showSubnavFacets
            showLoadMoreChoicesBtns lastUl()
            $loadMoreBtn = $(_sel_loadMoreChoices+_sel_loadMoreDeals+'-from-'+fragmentParams.setId)
            if $loadMoreBtn.length
              setupInitialOffset fragmentParams, $loadMoreBtn
          else
            setupInitialOffset fragmentParams
        else if fragmentParams.deal
          dealHref = unescape(fragmentParams.deal)
          scrollElementIntoView($("a[href='#{dealHref}']")[0])
        if $(_sel_loadMoreDeals).length < 1 # the results are exhausted - we may show the extra choices if they are enabled
          showLoadMoreChoicesBtns lastUl()
    window.addEventListener('popstate', popState)

  popStateCallback = () ->
    #Do nothing

  popState = (ev) ->
    if ev?.state?.stateQuery and not _.isEqual(lastState, ev.state.stateQuery)
      applyState(ev.state, popStateCallback, true)

  applyState = (state, callback, hasHistoryChanged) ->
    hasCats = hasHistoryChanged || false
    checkboxCount = 0
    priceCount = 0
    facetCount = 0
    sortCount = 0
    missingCheckboxCount = 0
    if state and state.stateQuery
      $('.nav-facets input:checked').prop('checked', false)
      $(_sel_priceFilter+' input:checked').prop('checked', false)
      $('#result-sorts input:checked').prop('checked', false)
      stateQuery = state.stateQuery
      for catType of stateQuery
        typeFirst8 = catType.substr(0,8)
        if typeFirst8 in ['topcateg', 'subcateg'] || catType in ['category', 'deal_type'] # please note ['category', 'subcateg'] is not an Array - check the compiled JS and avoid using [].indexOf
          hasCats = true
          categories = stateQuery[catType].split(',')
          for category in categories
            $input = $("#facet_#{catType}_"+category)
            missingCheckboxCount++ unless $input.length
            $input.prop('checked', true)
            checkboxCount++
            facetCount++
        else if catType == 'priceFilters'
          hasCats = true # bad variable name
          priceFilters = stateQuery[catType].split(',')
          for priceFilter in priceFilters
            priceFilter = priceFilter.replace('..','_').replace('*','infinity')
            $input = $(_sel_priceFilter+' #range_'+priceFilter)
            if not $input.length
              $price_filter_dest = $(_sel_priceFilter)
              $hasFilters = $price_filter_dest.find('input')
              if $hasFilters.length
                minmax = priceFilter.split('_')
                if minmax[0] and minmax[1]
                  $input = addCustomPriceRange($price_filter_dest, minmax[0], minmax[1])
              else
                missingCheckboxCount++ # this page does not support price range filtering
            $input.prop('checked', true)
            checkboxCount++
            priceCount++
        else if catType == 'sort'
          $input = $("#result-sorts input[id=\"sorts-#{stateQuery[catType]}\"]")
          # missingCheckboxCount++ unless $input.length # impossible sort choices are not invalid selections
          $input.prop('checked', true)
          sortCount++
      lastState = stateQuery
    if sortCount < 1
      $("#result-sorts input.default").prop('checked', true)
    if not hasHistoryChanged and missingCheckboxCount > 0
      hasHistoryChanged = true # during initial page load, if we have facets or other selections we loaded server side that really aren't selectable, we will reload based on whatever IS checked
    if hasHistoryChanged # hasCats if server side loading is disabled
      facetSelectionChanged({}, callback)
    else
      indicateFacetsSelected(checkboxCount, {price: priceCount, facets: facetCount, sorts: sortCount})
      callback()

  setupInitialOffset = (fragmentParams, loadMoreBtn) ->
    queryOffset = fragmentParams.offset-0
    setId = fragmentParams.setId or ''
    scrollId = queryOffset
    dealHref = unescape(fragmentParams.deal)
    if not loadMoreBtn or not loadMoreBtn.length
      loadMoreBtn = $(_sel_loadMoreDeals) # in rare conditions we may not find this on the page, in which case offset is probably not needed
    return unless loadMoreBtn.length

    offset = loadMoreBtn.attr(_attr_dataNextOffset) - 0
    if offset < queryOffset

      $destination = loadMoreBtn.closest('li')
      loadMoreBtnA = $destination.find('a') # loadMoreBtnA == loadMoreBtn ...
      $loadHiddenFragment = fragment()

      baseAttr = paginationCard.cloneAttributes loadMoreBtnA
      baseAttr = _.extend baseAttr, 
        'id': "load-previous-deals"
        'data-max-offset': queryOffset
        'data-next-offset': offset

      createLoadMoreButton $loadHiddenFragment, null, 'load-previous-deals', baseAttr
      # todo ideally the folllowing can be moved into createLoadMoreButton somehow.... or some form of createLoadHiddenDealsBtn
      $newCardLink = $loadHiddenFragment.find('a')
      remaining = queryOffset - offset
      $newCardLink.find('.merchant-name').text(I18n.pluralize remaining, _jsModulesMrchOcsn+'.hidden_deals')
      $newCardLink.find('.deal-title').text I18n.t _jsModulesMrchOcsn+'.show_hidden'
      $newCardLink.attr 'data-bhc', $newCardLink.attr('data-bhc').replace(/^pagination/, 'pagination_hidden')
      label = loadMoreBtnA.attr 'data-set-label'
      if label
        textNodeBefore $loadHiddenFragment.find('.deal-title'), label
      $loadHiddenFragment.insertBefore($destination)
      # finally move the pagination card to the appropriate offset
      loadMoreBtn.attr _attr_dataNextOffset, queryOffset
      updatePaginationCardHref(loadMoreBtn)
    loadMoreDeals loadMoreBtn, (success)->
      scrollToIt = () ->
        exact = $("a[href='#{dealHref}']")[0]
        rough = $("li[data-set='#{setId}'][data-offset='#{scrollId}']")[0]
        rough2 = $("li[data-set='#{setId}']")[0]
        rough3 = $("[data-offset='#{scrollId}']")[0]
        scrollElementIntoView(exact or rough or rough2 or rough3)
      setTimeout scrollToIt, 250

  scrollElementIntoView = (element) ->
    if element
      if typeof element.scrollIntoViewIfNeeded == 'function'
        element.scrollIntoViewIfNeeded()
      else if typeof element.scrollIntoView == 'function'
        element.scrollIntoView()
      else
        $('html, body').scrollTop($(element).offset().top)

  initPaginatedDealIds = () ->
    initialCards = $('figure.card-ui a')
    _.each initialCards, (dealCardLink) ->
      $dealCardLink = $(dealCardLink)
      paginatedDealIds[($dealCardLink.attr('href') || '').match(/[-\w]+$/)] = true
      return if $dealCardLink.hasClass(_id_loadMoreDeals) or $dealCardLink.closest('.cui-collection-pagination').length # for pagination cards we do not wish to attach event 
      $dealCardLink.on 'click', initiallyLoadedCardClicked

  newHeading = (innerText) ->
    return $('<div class="nav-heading" role="heading">'+innerText+'</div>')

  showPriceFilters = (createHeading)->
    $dest = $(_sel_priceFilter)
    if pageConfig.showPriceFilter and pageConfig.priceFilters and $dest.length and (pageConfig.dealCount > 0 or initialQueryString.priceFilters)
      currencyOpts = {currencyCode: pageConfig.priceFilters.code, short:true}
      $priceFilter = fragment()
      for range in pageConfig.priceFilters.ranges
        name = I18n.toCurrency(range.from, currencyOpts)
        if range.to != "*"
          name += " " + I18n.t(_jsModulesMrchOcsn+'.range_separator')
          name += " " + I18n.toCurrency(range.to, currencyOpts)
        else
          name += I18n.t(_jsModulesMrchOcsn+'.range_infinite')
        range.name = name
        range.safeTo = "#{range.to}".replace("*",'infinity')
        $rangeCheckbox = $(priceRangeTemplate.render range)
        $rangeCheckbox.find('input').on('change', facetSelectionChangeDebounced)
        $priceFilter.append($rangeCheckbox)
      if pageConfig.allowCustomPriceRange
        addCustomPriceRange($priceFilter)
      newHeading(I18n.t(_jsModulesMrchOcsn+'.price_ranges')).insertBefore($dest) if createHeading
      $dest.append($priceFilter)
      $(_sel_priceFilter+'-trigger').show()

  addCustomPriceRange = ($priceFilter, min, max) ->
    $custom = $('#range_custom')
    return $custom if $custom.length
    range = {
      min: min || "",
      max: max || "",
      name: I18n.t(_jsModulesMrchOcsn+'.range_separator')
    }
    $rangeCheckbox = $(priceRangeCustTemplate.render range)
    $rangeCheckbox.find('input#range_custom').on('change', facetSelectionChangeDebounced)
    $rangeCheckbox.find('input.custom-price-range').on('change keyup', customPriceRangeChanged)
    $priceFilter.append($rangeCheckbox)
    if min and max
      computeCustomRange()
    return $rangeCheckbox.find('input#range_custom')

  computeCustomRange = () ->
    $custom = $('#range_custom')
    return unless $custom.length
    checked = $custom.prop('checked')
    min = $('#custom_price_min').val()
    max = $('#custom_price_max').val()
    if Math.max(min, max)+'' == min # user reversed range
      oldMax = max
      max = min
      min = oldMax
    if !min || !max || min-0 >= max-0
      $custom.prop('checked', false)
      return false
    else
      $custom.data('range', "#{min}..#{max}")
      return true

  customPriceRangeChanged = (ev) ->
    return if ev.keyCode in [9, 16, 37, 39] # 9 tab key, 16 shift key, 37 left arr, 39 right arr
    $custom = $('#range_custom')
    checked = $custom.prop('checked')
    $custom.prop('checked', false)
    if checked
      facetSelectionChangeDebounced({})
    if ev.keyCode == 13
      if computeCustomRange() # enter key and valid range
        $custom.prop('checked', true)
        facetSelectionChangeDebounced({})

  showSortOptions = (createHeading)->
    $dest = $('#result-sorts')
    if pageConfig.showPriceFilter and pageConfig.sorts and $dest.length and pageConfig.dealCount > 0
      $sorts = fragment()
      for sort in pageConfig.sorts
        $sortRaio = $(radioTemplate.render _.extend(sort, {type: 'sorts'}))
        $sortRaio.find('input').on('change', facetSelectionChangeDebounced)
        $sorts.append($sortRaio)
      newHeading(I18n.t(_jsModulesMrchOcsn+'.sort_by')).insertBefore($dest) if createHeading
      $dest.append($sorts)
      $('#result-sorts-trigger').show()

  showSubnavAreaFacets = (facetAreaFacets, createHeading) ->
    $dest = $('#facet-area-filters')
    if facetAreaFacets.length and pageConfig.subnavFacetAreaTitle and $dest.length
      $facetArea = fragment()
      for facet in facetAreaFacets
        $facetTemplate = $(facetTemplate.render facet)
        $facetTemplate.find('input').on('change', facetSelectionChangeDebounced)
        $facetArea.append($facetTemplate)
      newHeading(pageConfig.subnavFacetAreaTitle).insertBefore($dest) if createHeading
      $dest.append($facetArea)

  showSubnavFacets = (subnavFacets) ->
    $liHolder = $('#facet-filters')
    if subnavFacets.length and pageConfig.showSubnavFacets and $liHolder.length
      for facet in subnavFacets
        $facetTemplate = $(facetTemplate.render facet)
        $facetTemplate.find('input').on('change', facetSelectionChangeDebounced)
        $liHolder.append($facetTemplate)
      $liHolder.prev('.nav-heading').show()
      $liHolder.show().addClass('nav-facets')
      $('#facet-filters-trigger').show()

  getDivisionLatLng = () ->
    return paginationCard.getDivisionLatLng(pageConfig)

  getDivisionLocale = () ->
    return paginationCard.getDivisionLocale(pageConfig)

  getSelectableCategories = () ->
    getCategoriesForCheckboxes($('.nav-facets input'))

  getSelectedCategories = () ->
    getCategoriesForCheckboxes($('.nav-facets input:checked'))

  getFacetAreaCategories = () ->
    getCategoriesForCheckboxes($('#facet-area-filters input:checked'))

  getCategoriesForCheckboxes = (catCheckboxes) ->
    foundCats = []
    queryCats = []
    mappedCats = {}
    _.each catCheckboxes, (chk) ->
      $chk = $(chk)
      catType = $chk.data('category-type')
      name = $chk.data('category-name')
      cat =  $chk.data('category')
      query = catType + ':' + cat
      queryCats.push(query)
      foundCats.push
        type: catType
        id: cat
        name: name
        query: query
      if not mappedCats[catType]
        mappedCats[catType] = cat
      else mappedCats[catType] += ",#{cat}"
    catQuery = queryCats.join(" OR ")
    {foundCats, mappedCats, catQuery}

  getSelectedPriceRanges = () ->
    computeCustomRange()
    checkedRanges = $(_sel_priceFilter+' input:checked')
    foundRanges = []
    mappedRanges = {}
    priceFilter = ""
    _.each checkedRanges, (chk) ->
      $chk = $(chk)
      foundRanges.push($chk.data('range'))
    if foundRanges.length
      priceFilter = " AND price:["+foundRanges.join('];[')+"]"
      mappedRanges.priceFilters = foundRanges.join(',')
    {priceRanges: foundRanges, mappedRanges, priceFilter}

  getSelectedSortMap = () ->
    map = {}
    sort = urlUtils.getSelectedSort()
    map.sort = sort if sort
    return map

  indicateFacetsSelected = (totalSelections, changeMeta) ->
    $responsiveBtn = $('#sidebar-toggle button')
    if $responsiveBtn.length
      if totalSelections > 0
        $responsiveBtn.text I18n.pluralize(totalSelections, _jsModulesMrchOcsn+'.options_selected')
      else
        $responsiveBtn.text I18n.t(_jsModulesMrchOcsn+'.options_title')
    else # touch
      $(_sel_priceFilter+'-trigger').toggleClass('active c-bg-prim', !!changeMeta.price)
      $('#facet-filters-trigger').toggleClass('active c-bg-prim', !!changeMeta.facets)
      $('#result-sorts-trigger').toggleClass('active c-bg-prim', !!changeMeta.sorts)

  urlTemplateBuilder = (urlPath, setId) ->
    url = pageConfig.occasion.permalink + urlPath + '#offset={OFFSET}'
    if setId
      url += "&setId=" + setId
    return url

  updatePaginationCardHref = (loadMoreBtn) ->
    newHref = loadMoreBtn.attr(_attr_dataHrefTemplate)
    if !newHref
      newHref = urlTemplateBuilder("")
    newHref = paginationTemplateUrlSetOffset(newHref, loadMoreBtn.attr(_attr_dataNextOffset))
    loadMoreBtn.attr("href", newHref)

  paginationTemplateUrlSetOffset = (href, offset) ->
    return href.replace('{OFFSET}', offset)

  getHeroDealNode = () ->
    return $('#heroContainer')

  getCurrentDealNodes = () ->
    return $('#result-list > ul > li')

  lastUl = () ->
    $('#result-list > ul:last')

  getErrorNode = () ->
    return $('#nodeals')

  loadingDeals = () ->
    $('#result-list,#featured').css('opacity', 0.5)
    $('#loading').show()

  notLoadingDeals = () ->
    $('#result-list,#featured').css('opacity', 1.0)
    $('#loading').hide()

  facetSelectionChanged = (ev, callbackFn) ->
    {foundCats, mappedCats, catQuery} = getSelectedCategories()
    {priceRanges, mappedRanges, priceFilter} = getSelectedPriceRanges()
    sortMap = getSelectedSortMap()
    stateMap = _.extend({}, mappedRanges, mappedCats, sortMap)
    urlPath = urlUtils.buildQueryString stateMap
    totalSelections = 0

    filterQuery = "(#{pageConfig.occasion.apiRapiFilterDefault})" or "deal_type:#{pageConfig.occasion.dealType}"
    if foundCats.length
      filterQuery += " AND (#{catQuery})"
      totalSelections += foundCats.length
    latLng = getDivisionLatLng()
    divisionLocale = getDivisionLocale()

    if priceRanges.length
      filterQuery += priceFilter
      totalSelections += priceRanges.length

    indicateFacetsSelected(totalSelections, {price: priceRanges.length, facets: foundCats.length, sorts: sortMap.sort})

    query_filter_string = urlUtils.apiQueryBuilder _.extend({
      filterQuery: filterQuery
      latLng: latLng
      divisionLocale: divisionLocale
      includeHtml: pageConfig.newRender
      noHero: pageConfig.isTouch
    }, pageConfig.occasion)

    offset = 0
    limit = pageConfig.pageLimit

    heroDeal = getHeroDealNode()
    nodesToClearOnSuccess = getCurrentDealNodes()

    $loadMoreBtnA = createLoadMoreButton lastUl(), false, false,
      'data-filter-query': filterQuery
      'data-division-loc': latLng
      'data-href-template': urlTemplateBuilder(urlPath)
    $loadMoreBtn = $loadMoreBtnA.closest('li')
    $loadMoreBtn.hide() # avoid duplicate loading spinners...

    oldPaginatedIds = paginatedDealIds
    paginatedDealIds = {} # if the load is successful, we clear the prior results, so do not dedupe against them, we'll set this back later if the results fail to load
    loadingDeals()

    loadDeals $loadMoreBtnA, $loadMoreBtn, query_filter_string, offset, limit, false, nodesToClearOnSuccess, heroDeal, (success, dupe) ->
      $loadMoreBtn.show()
      notLoadingDeals()
      if success
        newState = {stateQuery:stateMap}
        if history.pushState and not _.isEqual(history.state, newState) # we should not push state if our current state is already represented (initial page load time)
          lastState = stateMap
          history.pushState(newState,document.title,window.location.pathname + urlPath) # + urlUtils.currentFragment() # if we do not drop the fragment, we should make sure to at least set the offset to 0
        OptimizeSuite.treatAsNewPage(window.location.pathname + urlPath)
        callbackFn?()
      else
        paginatedDealIds = oldPaginatedIds unless dupe
        $loadMoreBtn.remove()

  # the debounced version of facetSelectionChanged will only be called once per given interval, allows us to react only once to many changes
  facetSelectionChangeDebounced = _.debounce(facetSelectionChanged, 400)

  textNode = (text) ->
    document.createTextNode(text)

  fragment = () ->
    $(document.createDocumentFragment())

  textNodeBefore = ($elm, text) ->
    $elm.prepend($('<br/>'))
    $elm.prepend(textNode(text))

  initiallyLoadedCardClicked = (ev) ->
    $target = $(ev.currentTarget)
    $a = $target
    href = $a.attr 'href'
    if href
      urlUtils.setFragment "deal=#{escape(href)}"

  clonedCardClicked = (ev) ->
    $target = $(ev.currentTarget)
    $a = $target.find('a')
    offset = $target.attr 'data-offset'
    href = escape($a.attr 'href')
    extraFilter = getExtraFilter($a)
    urlUtils.setFragment "offset=#{offset}&deal=#{href}#{extraFilter}"

  scrollUpIfNeeded = ($target)->
    scrolly = $(window).scrollTop()
    btnPosition = $target.offset().top - 60
    if( btnPosition < scrolly )
      window.scrollBy(0, btnPosition - scrolly)

  loadMoreDealsEvent = (ev, optionalCbf)->
    ev?.preventDefault()
    loadMoreBtn = $(this)
    scrollUpIfNeeded loadMoreBtn
    loadMoreDeals(loadMoreBtn, optionalCbf)
    offset = loadMoreBtn.attr(_attr_dataNextOffset) - 0
    extraFilter = getExtraFilter(loadMoreBtn)
    if offset or extraFilter
      urlUtils.setFragment "offset=#{offset}#{extraFilter}" # if we are using push state, we neeed to be careful here, to see if anything actually changed before trying to load anything

  getExtraFilter = ($a)->
    extraFilter = ''
    setId = $a.attr(_attr_dataSetId)
    if setId
      extraFilter = "&setId=#{setId}"
    return extraFilter

  loadMoreDeals = (loadMoreBtn, callbackFn) ->
    query_filter_string = urlUtils.apiQueryBuilder paginationCard.loadButtonAttributes(loadMoreBtn, pageConfig)
    offset = loadMoreBtn.attr(_attr_dataNextOffset) - 0
    limit = (loadMoreBtn.attr("data-limit") - 0) or 99
    maxOffset = loadMoreBtn.attr("data-max-offset") - 0
    # return unless offset and offset > 0
    loadDeals loadMoreBtn, loadMoreBtn.parents('li'), query_filter_string, offset, limit, maxOffset, [], false, callbackFn

  heroReadyToShow = (hero, paginatedKey) ->
    hero.show()
    paginatedDealIds[paginatedKey] = true

  setLoadingStatus = (loadMoreFigure, status) ->
    loadMoreFigure.removeClass('retry loading')
    loadMoreFigure.addClass(status) if status

  checkRemainingDeals = (total, offset, limit) ->
    remaining = total - offset
    moreDeals = true
    if total and (remaining <= (limit+MIN_PAGE_DEALS))
      moreDeals = false
    return moreDeals

  cardsForResp = (json) ->
    return json.deals or json.cards

  htmlForDeal = (deal) ->
    return deal.cardHtml

  dataForDeal = (deal) ->
    return deal.data or deal

  metaForDeal = (deal) ->
    dealData = dataForDeal(deal)
    paginatedKey = if dealData.optionUuid then dealData.id + '_' + dealData.optionUuid else dealData.id
    return {dealData: dealData, cardHtml: htmlForDeal(deal), paginatedKey: paginatedKey}

  loadDeals = (loadMoreBtn, loadMoreBtnLi, query_filter_string, offset, limit, maxOffset, toRemoveOnSuccess, optionalHero, callbackFn) ->
    loadMoreParentLi = loadMoreBtn.closest('li')
    loadMoreFigure = loadMoreBtn.closest('figure')
    setLoadingStatus(loadMoreFigure, 'loading')
    setId = loadMoreBtn.attr(_attr_dataSetId) or ''
    total = loadMoreBtn.attr(_attr_dataTotalDeals) - 0
    remainingDeals = checkRemainingDeals(total, offset, limit)
    if !remainingDeals
      limit += LIMIT_INCREMENT
    url = "/occasion/deals-json?#{query_filter_string}&offset=#{offset}&limit=#{limit}" + extraQueryString
    lastRequest = url
    $.ajax
      url: url
      dataType: "json"
      timeout: 8000
      success: (json) ->
        setLoadingStatus(loadMoreFigure, false)
        getErrorNode().remove();
        if lastRequest != url
          # another subsequent request is newer, skip this
          callbackFn?(false, true)
          return
        cards = cardsForResp json
        if cards
          r = 0
          rl = cards.length
          total = json.pagination.count
          newOffset = json.pagination.nextOffset
          if not setId # touch indicates result count
            $('.result-count').text I18n.pluralize(total, _jsModulesMrchOcsn+'.view_deals_count')
          if toRemoveOnSuccess.length
            toRemoveOnSuccess.remove()
          if optionalHero and optionalHero.length
            if rl > 0
              {dealData, cardHtml, paginatedKey} = metaForDeal cards[r]
              if cardHtml
                optionalHero.empty().append($(cardHtml))
                heroReadyToShow(optionalHero, paginatedKey)
                getCardUi().init(optionalHero.find('.card-ui').not('.is-initialized'))
                if pageConfig.isTouch
                  $('html,body').animate({scrollTop: 0}); # optionalHero.offset().top
                r++
              else
                optionalHero.hide()
            else
              optionalHero.hide()
          if newOffset == offset # we didn't acutally get any new deals back from the request... API lied about the total
            outOfDeals(loadMoreParentLi, total)
            callbackFn?(true)
            return
          loadMoreBtn.attr(_attr_dataNextOffset, newOffset)
          loadMoreBtn.attr(_attr_dataTotalDeals, total)
          updatePaginationCardHref(loadMoreBtn)
          while r < rl
            {dealData, cardHtml, paginatedKey} = metaForDeal cards[r]
            if not paginatedDealIds[paginatedKey]
              if cardHtml
                newCard = $(cardHtml)
                newCard.find('a').attr('data-limit', 1) # supports same integration test in if cardHtml branch
                newCard.find('a').attr(_attr_dataSetId, setId)
                newCard.insertBefore(loadMoreParentLi)
                newCard.on 'click', clonedCardClicked
                newCard.attr 'data-offset', offset
                newCard.attr 'data-set', setId if setId
                paginatedDealIds[paginatedKey] = true
            r++
          Groupon.Utils.lazyLoadImages()
          getCardUi().init($('.card-ui').not('.is-initialized'))
          if offset + rl >= total or newOffset >= total or (maxOffset and newOffset >= maxOffset)
            outOfDeals(loadMoreParentLi, total)
          else
            if maxOffset
              remaining = maxOffset - newOffset
              loadMoreBtn.find('.merchant-name').text(I18n.pluralize(remaining, _jsModulesMrchOcsn+'.hidden_deals'))
            else
              remaining = total - newOffset
              loadMoreBtn.find('.merchant-name').text(I18n.pluralize(remaining, _jsModulesMrchOcsn+'.remaining_deals'))
          callbackFn?(true)
      error: ->
        setLoadingStatus(loadMoreFigure, 'retry')
        callbackFn?(false)

  outOfDeals = (loadMoreParentLi, total) ->
    ulContainer = loadMoreParentLi.closest('ul')
    loadMoreChoices = $(_sel_loadMoreChoices)
    loadMorePaginationCard = loadMoreParentLi.find(_sel_loadMoreChoices)
    loadMoreParentLi.remove()
    if loadMoreChoices.length == 0 # we may have just removed the last .load-more-choices, but we still counted it first, so we will not create them more than once
      showLoadMoreChoicesBtns(ulContainer)
    $heroNode = getHeroDealNode()
    if loadMorePaginationCard.length < 1 && total < 1 && getErrorNode().length < 1 && $heroNode.length
      $heroNode.before($('<div id="nodeals" class="no_deals"><div class="message">'+pageConfig.error+'</div></div>'))
      if pageConfig.isTouch
        $('html,body').animate({scrollTop: 0}); # $heroNode.offset().top

  showLoadMoreChoicesBtns = (ulContainer) ->
    return unless pageConfig.showMoreChoices
    loadMoreChoices = $(_sel_loadMoreChoices)
    return unless loadMoreChoices.length == 0
    {foundCats, mappedCats} = getSelectedCategories()
    {priceRanges, mappedRanges, priceFilter} = getSelectedPriceRanges()
    stateMap = _.extend({}, mappedRanges, mappedCats, getSelectedSortMap())
    urlPath = urlUtils.buildQueryString stateMap
    if foundCats.length
      setId = 'dealtype'
      hrefTemplate = urlTemplateBuilder(urlPath, 'dealtype')
      createLoadMoreButton ulContainer, pageConfig.occasion.displayName, _cls_loadMoreChoices,
        id: _id_loadMoreDeals+"-from-#{setId}"
        'data-set-id': setId
        'data-nohero': true
        'data-href-template': hrefTemplate
        'href': paginationTemplateUrlSetOffset(hrefTemplate, '0')
      latLng = getDivisionLatLng()
    else
      {foundCats} = paginationFacets.getCategories()
      if not foundCats.length
        {foundCats} = getSelectableCategories()
    if foundCats.length
      for cat in foundCats
        catQuery = cat.query
        if priceRanges.length
          catQuery += priceFilter
        hrefTemplate = urlTemplateBuilder(urlPath, cat.id)
        createLoadMoreButton ulContainer, cat.name, _cls_loadMoreChoices,
          'id': _id_loadMoreDeals+"-from-#{cat.id}"
          'data-set-id': cat.id
          'data-nohero': true
          'data-filter-query': catQuery
          'data-division-loc': latLng
          'data-href-template': hrefTemplate
          'href': paginationTemplateUrlSetOffset(hrefTemplate, '0')
          # we may want to set the href to support open pagination card in new tab

  createLoadMoreButton = ( container, title, classes, extraAttr ) ->
    paginationBhc = "dealType-" + pageConfig.occasion.dealType
    if extraAttr[_attr_dataFilterQuery]
      paginationBhc = "filter-" + escape(extraAttr[_attr_dataFilterQuery])
    else if pageConfig.occasion.isCategoryFallback and pageConfig.occasion.categoryFallback
      paginationBhc = "catFallback-" + escape(pageConfig.occasion.categoryFallback)
    $loadMoreBtn = $(loadMoreTemplate.render I18n.mixin(campaign: pageConfig.occasion, pageLimit: pageConfig.pageLimit, newRenderEnabled: pageConfig.newRender, allowRapi: true, nextOffset: 0, paginationBhc: paginationBhc), hoganPartials)
    $loadMoreBtnA = $loadMoreBtn.find('a'+_sel_loadMoreDeals)
    if classes
      $loadMoreBtnA.addClass(classes)
    if title
      textNodeBefore $loadMoreBtnA.find('.deal-title'), title
      $loadMoreBtnA.attr('data-set-label', title)
    for key, value of extraAttr
      $loadMoreBtnA.attr(key, value)
    if !extraAttr['href'] and extraAttr[_attr_dataHrefTemplate]
      $loadMoreBtnA.attr('href', paginationTemplateUrlSetOffset(extraAttr[_attr_dataHrefTemplate], '0'))
    $loadMoreBtnA.on('click', loadMoreDealsEvent)
    container.append($loadMoreBtn)
    $loadMoreBtnA

  return {
    init: _init
    initCui: initCui
    getCardUi: getCardUi
    loadMoreDealsEvent: loadMoreDealsEvent
    cardsForResp: cardsForResp
    htmlForDeal: htmlForDeal
    dataForDeal: dataForDeal
    facetSelectionChanged: facetSelectionChangeDebounced
    paginatedDealIds: paginatedDealIds
  }

window.MerchandisingFiltering = Filtering
module.exports = Filtering
